<div class="flex items-center justify-center {{ theme?.root }}">
  <div class="container {{ theme?.container }}">
    @if (displayPrice) {
      <div class="flex-col pricing py-v-spacing sm:px-v-spacing max-w-container mx-auto">
        <div class="mr-v-spacing flex items-baseline prices" [innerHtml]="pricingText"></div>
      </div>
    }
    @if (!!ctaLabel) {
      <vision-button defaultStyle="primary" [data]="ctaButtonData"></vision-button>
    }
  </div>
</div>
